"use client"

import { useState } from "react"
import { useAuth } from "../contexts/AuthContext"
import { useLanguage } from "../contexts/LanguageContext"
import { LanguageSelector } from "./LanguageSelector"
import { Icons } from "./Icons"

export function LoginForm() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const { login } = useAuth()
  const { t } = useLanguage()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setIsLoading(true)

    try {
      await login(email, password)
    } catch (err) {
      setError(err.message || t("auth.authError"))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="card max-w-md w-full">
        <div className="card-header">
          <div className="flex justify-between items-center space-x-4">
            <h1 className="card-title flex items-center space-x-2">
              <Icons.User className="w-6 h-6 text-blue-600" />
              <span>{t("auth.loginTitle")}</span>
            </h1>
            <LanguageSelector />
          </div>
          <p className="card-description">{t("auth.loginDescription")}</p>
        </div>
        <div className="card-content">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label" htmlFor="email">
                {t("auth.email")}
              </label>
              <input
                id="email"
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("auth.enterEmail")}
                required
              />
            </div>
            <div>
              <label className="label" htmlFor="password">
                {t("auth.password")}
              </label>
              <input
                id="password"
                type="password"
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t("auth.enterPassword")}
                required
              />
            </div>
            {error && <div className="alert alert-error">{error}</div>}
            <button
              type="submit"
              className="btn btn-primary w-full flex items-center justify-center space-x-2"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Icons.Spinner className="w-4 h-4" />
                  <span>{t("auth.loggingIn")}</span>
                </>
              ) : (
                <>
                  <Icons.User className="w-4 h-4" />
                  <span>{t("auth.loginButton")}</span>
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
